import { render, staticRenderFns } from "./RetouchersOrderFuncBased.vue?vue&type=template&id=57c63035&"
import script from "./RetouchersOrderFuncBased.vue?vue&type=script&lang=js&"
export * from "./RetouchersOrderFuncBased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports